import { Loading } from '@components/loadling';
import { initSdk } from '@proccess/api';
import sdk from '@proccess/sdk';
import { PayloadAction } from '@reduxjs/toolkit';
import { actions } from '@store/reducer';
import { AxiosResponse } from 'axios';
import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { RequestAddress, TypeAddress } from './@types';
import { resourceActions } from './slice';

const urlTypeAddress = (type: TypeAddress) => {
  switch (type) {
    case 'city':
      return 'resource/getcity';

    case 'district':
      return 'resource/getdistrict';

    case 'ward':
      return 'resource/getward';

    default:
      return 'resource/getward';
  }
};

function* requestAddress({ payload: { code, type } }: PayloadAction<RequestAddress>) {
  try {
    const response: AxiosResponse = yield call(() =>
      initSdk.get(urlTypeAddress(type), {
        params: {
          ...code,
        },
      })
    );

    if (response.data) {
      yield put(resourceActions.saveAddress({ data: response.data, type }));
    }
  } catch (error) {
    console.error('error', error);
    Loading.Hide();
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestAddress() {
  yield takeEvery(resourceActions.requestAddress, requestAddress);
}

function* requestNation() {
  try {
    const response: AxiosResponse = yield call(() => sdk.getNation());

    if (response.data) {
      yield put(actions.saveNation({ data: response.data }));
    }
  } catch (error) {
    console.error('error', error);
    Loading.Hide();
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestNation() {
  yield takeLatest(actions.requestNation, requestNation);
}

function* requestRelative() {
  try {
    const response: AxiosResponse = yield call(() => sdk.getRelative());

    if (response.data) {
      yield put(actions.saveRelative({ data: response.data }));
    }
  } catch (error) {
    console.error('error', error);
    Loading.Hide();
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestRelative() {
  yield takeLatest(actions.requestRelative, requestRelative);
}

function* requestProfession() {
  try {
    const response: AxiosResponse = yield call(() => sdk.getProfession());
    if (response.data) {
      yield put(actions.saveProfession({ data: response.data }));
    }
  } catch (error) {
    console.error('error', error);
    Loading.Hide();
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestProfession() {
  yield takeLatest(actions.requestProfession, requestProfession);
}

const resourceSagas = function* root() {
  yield all([
    fork(watcherRequestAddress),
    fork(watcherRequestNation),
    fork(watcherRequestProfession),
    fork(watcherRequestRelative),
  ]);
};
export { resourceSagas };
